import { HTMLAttributes } from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-[3px] border px-2 py-[2px] text-[10px] tracking-[0.06em] font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground shadow hover:opacity-80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:opacity-80",
        destructive: "border-transparent bg-destructive text-destructive-foreground shadow hover:opacity-80",
        outline: "text-foreground",
        aqua: "bg-[#d946ef]/10 text-[#d946ef] border-[#d946ef]/20",
        soroswap: "bg-[#818cf8]/10 text-[#818cf8] border-[#818cf8]/20",
        phoenix: "bg-[#fb923c]/10 text-[#fb923c] border-[#fb923c]/20",
        blend: "bg-[#4ade80]/10 text-[#4ade80] border-[#4ade80]/20",
        comet: "bg-[#38bdf8]/10 text-[#38bdf8] border-[#38bdf8]/20",
        sdex: "bg-[#fbbf24]/10 text-[#fbbf24] border-[#fbbf24]/20",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps extends HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
